import LanguageIcon from "@mui/icons-material/Language";
import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function PublicLanguageSelect() {
  const { push, pathname, query, asPath, locales, locale } = useRouter();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t: localeT, i18n } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:LanguageCodes",
  });
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:PublicLanguageSelect",
  });
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [i18n, locale]);

  function selectLanguage(nextLocale: string) {
    setAnchorEl(null);
    push({ pathname, query }, asPath, { locale: nextLocale });
    i18n.changeLanguage(nextLocale);
  }

  return (
    <>
      {isMobile ? (
        <IconButton
          color="inherit"
          aria-label={t("buttonAriaLabel")}
          data-testid="public-language-select-button"
          onClick={(e) => {
            setAnchorEl(e.target as HTMLElement);
          }}
        >
          <LanguageIcon />
        </IconButton>
      ) : (
        <Button
          color="inherit"
          aria-label={t("buttonAriaLabel")}
          startIcon={<LanguageIcon />}
          data-testid="public-language-select-button"
          onClick={(e) => {
            setAnchorEl(e.target as HTMLElement);
          }}
        >
          {localeT(locale!)}
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {locales
          ?.filter((loc) => loc !== "default")
          .map((loc) => (
            <MenuItem
              key={loc}
              onClick={() => {
                selectLanguage(loc);
              }}
            >
              {localeT(loc)}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}
